import { Flex, Pill, Text, ToggleDetails } from "@instructure/ui";
import { t } from "i18next";
import React, { useMemo } from "react";
import { getPastVersions } from "./utils";

const ArchivedOutcome = ({ outcome }) => {
  const pastVersions = useMemo(() => getPastVersions(outcome), [outcome]);

  return (
    <>
      <Flex wrap="wrap" gap="small">
        <Flex.Item shouldGrow shouldShrink>
          <Text weight="bold" lineHeight="double">
            {outcome.name}{" "}
          </Text>
          {outcome.outcome_variety === "standard" && (
            <Pill color="info" margin="0 small 0 0">
              {t("learningOutcomes.standard")}
            </Pill>
          )}
          <Pill>
            {t("learningOutcomes.archive.archived")}{" "}
            {outcome.archive_term.insights_term_id}
          </Pill>
        </Flex.Item>
      </Flex>
      <Flex wrap="wrap" gap="xx-small">
        <Flex.Item size="100%">
          <Text size="small">{outcome.statement}</Text>
        </Flex.Item>
        {pastVersions.length > 0 && (
          <Flex.Item size="100%">
            <ToggleDetails
              summary={<Text size="small">{t("review.versionHistory")}</Text>}
            >
              {pastVersions.map((version, key) => (
                <Text color="brand" size="small" key={key}>
                  <Flex width="100%" alignItems="start">
                    <Flex.Item shouldGrow shouldShrink>
                      {version.statement}
                    </Flex.Item>
                    <Flex.Item>
                      {version.effective_term?.start_at
                        ? new Date(
                            version.effective_term.start_at
                          ).toLocaleDateString()
                        : new Date(version.last_updated).toLocaleDateString()}
                    </Flex.Item>
                  </Flex>
                </Text>
              ))}
            </ToggleDetails>
          </Flex.Item>
        )}
      </Flex>
    </>
  );
};

export default ArchivedOutcome;
